import { render, staticRenderFns } from "./DisplayErrors.vue?vue&type=template&id=7a9eb3b7&scoped=true"
import script from "./DisplayErrors.vue?vue&type=script&lang=ts"
export * from "./DisplayErrors.vue?vue&type=script&lang=ts"
import style0 from "./DisplayErrors.vue?vue&type=style&index=0&id=7a9eb3b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9eb3b7",
  null
  
)

export default component.exports